<template>
  <div class="hnair-pay hnair-pay-box">
    <div>
      组合支付：
      <template v-if="yktResponse.fare && yktResponse.caseFare">
        <span class="hnair-pay-span">{{ '海航通' + yktResponse.fare }}</span>
        <span class="hnair-pay-span">+</span>
        <span class="hnair-pay-span">{{ '第三方支付' + yktResponse.caseFare }}</span>
      </template>
      <template v-else>
        <span>余额不足，不能使用海航通账户支付</span>
      </template>
    </div>
    <div>
      <img class="hnair-pay-icon" :src="hnairPayIcon" alt="海航通余额"><span class="hnair-pay-price">余额：{{ yktResponse.oddFare }}</span><span class="hnair-pay-price">本单抵扣：{{ yktResponse.deduFare }}</span>
      <span v-if="airline !== 'JD'">(不含初始3000元授信)</span>
    </div>
  </div>
</template>
<script>
import { queryBalance } from '@/apis/pay'
import hnairPayIcon from '../images/hnair-pay-icon.png'

// MOCK: 联调使用
const yktResponse = {
  'oddFare': '-', // 海航通余额
  'fare': '-', // 海航通
  'deduFare': '-', // 抵扣金额
  'caseFare': '-' // 现金支付金额 + 税费
}

export default {
  inject: {
    getOrderId: {
      value: 'getOrderId',
      default: null
    }
  },
  props: {
    // 销售渠道
    sellerCode: {
      type: String,
      default: ''
    },
    // 销售渠道Channel
    sellerChannel: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      yktResponse,
      hnairPayIcon,
      airline: window.__MICRO_ROOT__?.airline
    }
  },
  created () {
    const orderId = this.getOrderId?.()
    if (orderId) {
      const count = 1
      this.queryBalanceByApi(orderId, count)
    }
    // NOTE: 因为查询余额接口容易存在超时，产品要求“设置超时时间 & 重新发起一次查询”进行保障
    window.setTimeout(() => {
      if (this.yktResponse?.oddFare === '-') {
        this.queryBalanceByApi(orderId)
      }
    }, 6000)
  },
  methods: {
    async queryBalanceByApi (orderId) {
      try {
        const { sellerCode, sellerChannel } = this
        const params = {
          orderId,
          seller: sellerCode,
          sellerChannel
        }
        const { yktResponse = {} } = await queryBalance(params)
        this.yktResponse = yktResponse
      } catch (error) {
        console.log('error >>>> ', error)
      }
    }
  }
}
</script>
<style lang="less">
.hnair-pay {
  padding: 5px 0 10px 15px;
  line-height: 32px;
  color: #333;
  &-span {
    padding: 0 5px;
  }
  &-price {
    color: @primary-color;
    padding-right: 20px;
  }
  &-icon {
    width: 18px;
    margin-right: 5px;
    vertical-align: text-bottom;
  }
}
</style>
